<kla-simple-image
  [image]="surveyConfig.image"
  [imagePosition]="surveyConfig.imagePosition"
  [lineConfig]="lineConfig"
  [titleConfigurations]="titleConfig"
  [imageObject]="surveyConfig.imageObject">
  <kla-button content
    [backgroundColor]="surveyConfig.backgroundColor"
    [borderColor]="surveyConfig.borderColor"
    [minWidth]="surveyConfig.minWidth"
    [title]="surveyConfig.title"
    [color]="surveyConfig.color"
    [class]="'button-big config-link-button'"
    [textAlign]="surveyConfig.textAlign"
    [configLink]="surveyConfig.link">
  </kla-button>
</kla-simple-image>
